import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const ingredients = [{
  name: 'Ginger + Black Pepper',
  benefit: 'Deep warmth, circulation, penetration'
}, {
  name: 'Eucalyptus',
  benefit: 'Calms discomfort signals without numbing'
}, {
  name: 'Rosemary',
  benefit: 'Supports blood flow and tissue recovery'
}, {
  name: 'Botanical Oils',
  benefit: 'Fast absorption, clean delivery, zero residue'
}];
export function DrSebiIngredientsSection() {
  return <section className="py-16 bg-bone/50" data-id="element-658">
      <div className="max-w-3xl mx-auto px-6" data-id="element-659">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl p-8 sm:p-10 shadow-xl shadow-ginger/5 border border-ginger/10" data-id="element-660">
          <h2 className="text-2xl sm:text-3xl font-serif font-medium text-charcoal text-center mb-8" data-id="element-661">
            Ginext Ginger Oil Ingredients Breakdown
            <span className="block text-ginger text-lg font-sans font-normal mt-2" data-id="element-662">
              (Dr. Sebi–Aligned)
            </span>
          </h2>

          <div className="grid gap-4" data-id="element-663">
            {ingredients.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-lg bg-bone/30 hover:bg-bone/50 transition-colors" data-id="element-664">
                <div className="mt-1 w-5 h-5 rounded-full bg-herbal/20 flex items-center justify-center flex-shrink-0" data-id="element-665">
                  <Check className="w-3 h-3 text-herbal" data-id="element-666" />
                </div>
                <div data-id="element-667">
                  <span className="font-bold text-charcoal block mb-1" data-id="element-668">
                    {item.name}
                  </span>
                  <span className="text-charcoal-light" data-id="element-669">{item.benefit}</span>
                </div>
              </div>)}
          </div>

          <div className="mt-10 pt-8 border-t border-bone-dark text-center" data-id="element-670">
            <p className="text-xl font-serif italic text-charcoal mb-2" data-id="element-671">
              Final Thought
            </p>
            <p className="text-charcoal-light mb-4" data-id="element-672">
              Your joints aren’t broken. They’re cold, stagnant, and
              undernourished.
            </p>
            <p className="text-ginger font-medium text-lg" data-id="element-673">
              Restore the flow — and the body remembers what to do.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}